"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var decorators_1 = require("../util/decorators");
var type_1 = require("../util/type");
// todo: @opten/reflector? or @opten/initializer/reflector?
var Reflector = /** @class */ (function () {
    function Reflector() {
    }
    Reflector.prototype.annotations = function (typeOrFunc) {
        if (!type_1.isType(typeOrFunc)) {
            return [];
        }
        var parentCtor = getParentCtor(typeOrFunc);
        var ownAnnotations = this._ownAnnotations(typeOrFunc, parentCtor) || [];
        var parentAnnotations = parentCtor !== Object ? this.annotations(parentCtor) : [];
        return parentAnnotations.concat(ownAnnotations);
    };
    Reflector.prototype.propMetadata = function (typeOrFunc) {
        if (!type_1.isType(typeOrFunc)) {
            return {};
        }
        var parentCtor = getParentCtor(typeOrFunc);
        var propMetadata = {};
        if (parentCtor !== Object) {
            var parentPropMetadata_1 = this.propMetadata(parentCtor);
            Object.keys(parentPropMetadata_1).forEach(function (propName) {
                propMetadata[propName] = parentPropMetadata_1[propName];
            });
        }
        var ownPropMetadata = this._ownPropMetadata(typeOrFunc, parentCtor);
        if (ownPropMetadata) {
            Object.keys(ownPropMetadata).forEach(function (propName) {
                var decorators = [];
                if (propMetadata.hasOwnProperty(propName)) {
                    decorators.push.apply(decorators, __spread(propMetadata[propName]));
                }
                decorators.push.apply(decorators, __spread(ownPropMetadata[propName]));
                propMetadata[propName] = decorators;
            });
        }
        return propMetadata;
    };
    Reflector.prototype._ownAnnotations = function (typeOrFunc, parentCtor) {
        // API for metadata created by invoking the decorators.
        if (typeOrFunc.hasOwnProperty(decorators_1.ANNOTATIONS)) {
            return typeOrFunc[decorators_1.ANNOTATIONS];
        }
        return null;
    };
    Reflector.prototype._ownPropMetadata = function (typeOrFunc, parentCtor) {
        // API for metadata created by invoking the decorators.
        if (typeOrFunc.hasOwnProperty(decorators_1.PROP_METADATA)) {
            return typeOrFunc[decorators_1.PROP_METADATA];
        }
        return null;
    };
    return Reflector;
}());
exports.Reflector = Reflector;
function getParentCtor(ctor) {
    var parentProto = Object.getPrototypeOf(ctor.prototype);
    var parentCtor = parentProto ? parentProto.constructor : null;
    // Note: We always use `Object` as the null value
    // to simplify checking later on.
    return parentCtor || Object;
}
